import styled from 'styled-components';
import {StyledButton} from "../../../components/Buttons/DefaultButton/DefaultButton.styles";


export const Page = styled.div`
    height: 100%;
    width: 100%;
    overflow: auto;
`
export const Container = styled.div`
    padding: 0 1rem;
    overflow: auto;
    display: flex;
    flex-direction: column;
    background-color: val(--primary-contrast);
    align-items: start;
    @media (min-width: 768px) {
        padding: 0 2rem;
    }
    

  .inset {
    margin: 0 0 1rem;
    font-size:13px;
  }

  .halfWidth {
    max-width: 50%;
  }
`

export const ButtonContainer = styled.div`
  width: 100%;
  max-width: 24rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 2rem auto;
  padding-bottom: 2rem;
  align-self: center;
`

export const ContinueButton = styled(StyledButton)`
    width: 100%;
    align-self: center;
    `
